import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Cookies from 'js-cookie'
import LoginView from '../views/LoginView.vue'
import ProfileView from '../views/ProfileView.vue'
import ExploreView from '../views/ExploreView.vue'
import SpotifyCallback from '../views/SpotifyCallback.vue'
import { validateAuthentication } from '@/services/authService'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { requiresAuth: true }
  },

  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/profile',
    name: 'profile',
    component: ProfileView,
    meta: { requiresAuth: true }
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('../views/MapView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/weather',
    name: 'weather',
    component: () => import('../views/WeatherView.vue')
  },
  {
    path: '/hotels',
    name: 'hotels',
    component: () => import('../views/HotelsView.vue'),
    // meta: { requiresAuth: true }
  },
  {
    path: '/explore',
    name: 'explore',
    component: ExploreView,
    meta: { requiresAuth: true }
  },

  {
    path: '/callback',
    name: 'spotify-callback',
    component: SpotifyCallback
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard for authentication
router.beforeEach(async (to, from, next) => {
  // Check if user is authenticated locally
  const token = Cookies.get('session_id')
  const hasLocalAuth = !!token || !!localStorage.getItem('auth_token')

  // Import store dynamically to avoid circular dependency
  const store = await import('@/store').then(module => module.default)

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!hasLocalAuth) {
      // Redirect to login page if not authenticated locally
      next({ name: 'login' })
    } else {
      // Validate authentication with server (including IP check)
      const isValidAuth = await validateAuthentication()

      if (!isValidAuth) {
        // Clear local data and redirect to login if server validation fails
        store.commit('CLEAR_USER')
        next({ name: 'login' })
        return
      }

      // If authenticated and going to a protected route, ensure user data is loaded
      if (!store.state.user.email || store.state.user.email === 'guest@example.com') {
        try {
          // Fetch user data if not already loaded
          await store.dispatch('fetchUser')
          next()
        } catch (error) {
          // If fetching user data fails, redirect to login
          store.commit('CLEAR_USER')
          next({ name: 'login' })
        }
      } else {
        next()
      }
    }
  } else if (to.name === 'login' && hasLocalAuth) {
    // For login page, validate authentication before redirecting
    const isValidAuth = await validateAuthentication()

    if (isValidAuth) {
      // Redirect to home page if user is already logged in and trying to access login page
      next({ name: 'home' })
    } else {
      // Clear invalid auth data and allow access to login page
      store.commit('CLEAR_USER')
      next()
    }
  } else {
    next()
  }
})

export default router
